<!-- Platform Coverage (moved from the home to the foot of the themes page, owner 2026-10-11):
     rows are themes, columns are platforms. Each cell marks
     whether a theme ships on that marketplace. Scrolls horizontally on narrow
     screens with the theme column pinned. -->
<div class="coverage-matrix" *ngIf="coverageGroups.length > 0">
  <!-- Wide screens: the full themes × platforms matrix (scrolls horizontally
       with the theme column pinned). -->
  <!-- is-fit (owner 2026-10-15: the whole table on one screen): the table fills the frame, the platform
       columns share its width; the themes and the palettes tables alike (owner: always in sync) -->
  <div class="coverage-scroll is-fit" #coverageScroll *ngIf="!isSmallScreenCached">
    <table class="coverage-table is-fit" (mouseleave)="coverageHoverCol = null">
      <thead>
        <tr>
          <th class="coverage-col-theme" scope="col"
              [class.col-hover]="coverageHoverCol === -1"
              (mouseenter)="coverageHoverCol = -1"></th>
          <th class="coverage-cat-head" scope="colgroup"
              *ngFor="let g of coverageColumnGroups"
              [attr.colspan]="g.span">
            {{ g.category }}
          </th>
        </tr>
        <tr>
          <!-- Separate corner per header row: the category-row corner fades
               (left of IDE), the logo-row corner stays a solid line (left of
               the first platform). -->
          <th class="coverage-col-theme" scope="col"
              [class.col-hover]="coverageHoverCol === -1"
              (mouseenter)="coverageHoverCol = -1"></th>
          <th class="coverage-platform" scope="col"
              *ngFor="let plat of coveragePlatforms; let i = index"
              role="link" tabindex="0"
              [class.col-hover]="coverageHoverCol === i"
              [title]="'Browse themes on ' + plat.name"
              (mouseenter)="coverageHoverCol = i"
              (click)="goToThemesByPlatform(plat.name)"
              (keyup.enter)="goToThemesByPlatform(plat.name)">
            <img [src]="plat.logo" alt="" loading="lazy">
            <span>{{ plat.label }}</span>
          </th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let group of coverageGroups">
          <tr class="coverage-group-row">
            <td [attr.colspan]="coveragePlatforms.length + 1"
                (mouseenter)="coverageHoverCol = null">
              <div class="coverage-group-bar" [style.width.px]="coverageBarWidth">
                <span class="coverage-group-label">{{ group.category }}</span>
              </div>
            </td>
          </tr>
          <tr class="coverage-theme-row" *ngFor="let row of group.rows; let last = last"
              [class.is-group-last]="last">
            <td class="coverage-col-theme"
                [class.col-hover]="coverageHoverCol === -1"
                role="link" tabindex="0"
                [title]="'Open ' + row.name"
                (mouseenter)="coverageHoverCol = -1"
                (click)="goToCoverageTheme(row)"
                (keyup.enter)="goToCoverageTheme(row)">
              <span class="coverage-theme-name">
                <img [src]="row.logo" alt="" loading="lazy">
                {{ row.name }}
              </span>
            </td>
            <!-- A ticked cell is a link: it opens that theme's page with this
                 platform already selected. The whole cell is the target, like
                 the theme column, so the padding around the tick counts too. -->
            <td *ngFor="let cell of row.cells; let i = index"
                [class.is-available]="cell.state === 'done'"
                [class.is-linked]="cell.state === 'done'"
                [class.col-hover]="coverageHoverCol === i"
                [attr.role]="cell.state === 'done' ? 'link' : null"
                [attr.tabindex]="cell.state === 'done' ? 0 : null"
                [title]="cell.state === 'done'
                  ? 'Open ' + row.name + ' on ' + coveragePlatforms[i].name
                  : null"
                (mouseenter)="coverageHoverCol = i"
                (click)="goToCoverageCell(row, i)"
                (keyup.enter)="goToCoverageCell(row, i)"
                [ngSwitch]="cell.state">
              <span *ngSwitchCase="'done'"
                    class="coverage-check"
                    role="img"
                    [attr.aria-label]="'Open ' + row.name + ' on ' + coveragePlatforms[i].name">
                <svg viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M5 13l4 4L19 7" fill="none" stroke="currentColor"
                        stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </span>
              <span *ngSwitchCase="'planned'"
                    class="coverage-planned"
                    [title]="row.name + ' on ' + coveragePlatforms[i].name + ' (planned)'">
                Planned
              </span>
              <span *ngSwitchDefault class="coverage-missing" role="img" aria-label="Not available">&minus;</span>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>

  <!-- Narrow screens: a per-platform accordion instead of the wide matrix.
       Pick a platform to reveal the themes that ship (or are planned) on it. -->
  <div class="coverage-accordion" *ngIf="isSmallScreenCached">
    <div class="coverage-acc-item"
         *ngFor="let panel of coveragePlatformPanels; let i = index"
         [class.is-open]="coverageOpenPanel === i">
      <button type="button" class="coverage-acc-head"
              [attr.aria-expanded]="coverageOpenPanel === i"
              (click)="toggleCoveragePanel(i)">
        <img [src]="panel.platform.logo" alt=""
             class="coverage-acc-logo" loading="lazy">
        <span class="coverage-acc-name">{{ panel.platform.name }}</span>
        <span class="coverage-acc-count" aria-hidden="true">{{ panel.available.length + panel.planned.length }}</span>
        <span class="coverage-acc-chevron" aria-hidden="true">
          <svg viewBox="0 0 24 24"><path d="M6 9l6 6 6-6" fill="none" stroke="currentColor"
            stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
        </span>
      </button>

      <div class="coverage-acc-body" *ngIf="coverageOpenPanel === i">
        <!-- On phones the row IS the ticked cell, so it opens the theme with
             this platform selected, exactly as the tick does in the wide
             table. The planned rows below open the theme with no platform. -->
        <button type="button" class="coverage-acc-theme"
                *ngFor="let row of panel.available"
                [title]="'Open ' + row.name + ' on ' + panel.platform.name"
                (click)="goToCoverageCell(row, i)">
          <img [src]="row.logo" alt="" loading="lazy">
          <span class="coverage-acc-theme-name">{{ row.name }}</span>
          <span class="coverage-acc-check" role="img" aria-label="Available">
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M5 13l4 4L19 7" fill="none" stroke="currentColor"
                    stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </span>
        </button>

        <button type="button" class="coverage-acc-theme is-planned"
                *ngFor="let row of panel.planned"
                [title]="row.name + ' on ' + panel.platform.name + ' (planned)'"
                (click)="goToCoverageTheme(row)">
          <img [src]="row.logo" alt="" loading="lazy">
          <span class="coverage-acc-theme-name">{{ row.name }}</span>
          <span class="coverage-acc-planned">Planned</span>
        </button>

        <button type="button" class="coverage-acc-all"
                (click)="goToThemesByPlatform(panel.platform.name)">
          Browse all on {{ panel.platform.name }}
          <span aria-hidden="true">&rarr;</span>
        </button>
      </div>
    </div>
  </div>
</div>
